import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import {withRouter} from "react-router-dom";
import AppointmentsTable from "../../components/Tables/AppointmentsTable";
import withPermissions from "../../components/WithPermissions";

class Appointments extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Randevular"
                Breadcrumb={[
                  {name: "Randevular", navigate: ""},
                ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task">
                  <div className="header">
                    <h2>Randevular</h2>
                  </div>
                  <div className="body">
                    <AppointmentsTable>
                    </AppointmentsTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(Appointments)));

